















































import Vue from 'vue';

export default Vue.extend({
  name: 'EventListItem',
  props: ['events', 'markedForDeletionEnum'],
  methods: {
    localeDate(date: string) {
      return (new Date(date)).toLocaleDateString();
    }
  }
});
